import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

// Firebase configurations for different tenants
const firebaseConfigs = {
  severance: {
    apiKey: "AIzaSyCaUv5cNIf-fEy3QGMtqIJAug3O-QRdr2E",
    authDomain: "crowdsourced-ideas-8d7fe.firebaseapp.com",
    projectId: "crowdsourced-ideas-8d7fe"
  },
  evanston: {
    apiKey: "AIzaSyCCU8QNbupipKhwBiYCHEBrK3RrLDR42Lk",
    authDomain: "evanston-paw-ideas.firebaseapp.com", 
    projectId: "evanston-paw-ideas"
  }
};

// Store Firebase app instances
const firebaseApps: Record<string, FirebaseApp> = {};
const firebaseAuthInstances: Record<string, Auth> = {};

/**
 * Get tenant ID from various sources
 */
export function getTenantId(): string {
  // Get tenant from environment variable (set at deploy time)
  const envTenant = process.env.REACT_APP_TENANT_ID;
  if (envTenant && (envTenant === 'severance' || envTenant === 'evanston')) {
    console.log(`🏢 [TENANT] Using environment variable tenant: ${envTenant}`);
    return envTenant;
  }
  
  // For local development only - check query parameter  
  const urlParams = new URLSearchParams(window.location.search);
  const queryTenant = urlParams.get('tenant');
  if (queryTenant === 'evanston' || queryTenant === 'severance') {
    console.log(`🏢 [TENANT] Using query parameter tenant: ${queryTenant} (dev only)`);
    return queryTenant;
  }
  
  // Default to severance
  console.log(`🏢 [TENANT] Using default tenant: severance`);
  return 'severance';
}

/**
 * Get Firebase app for current tenant
 */
export function getFirebaseApp(tenantId?: string): FirebaseApp {
  const tenant = tenantId || getTenantId();
  
  if (!firebaseApps[tenant]) {
    const config = firebaseConfigs[tenant as keyof typeof firebaseConfigs];
    if (!config) {
      throw new Error(`No Firebase configuration found for tenant: ${tenant}`);
    }
    
    firebaseApps[tenant] = initializeApp(config, `app-${tenant}`);
    console.log(`🔥 [FIREBASE] Initialized Firebase app for tenant: ${tenant} (${config.projectId})`);
  }
  
  return firebaseApps[tenant];
}

/**
 * Get Firebase Auth instance for current tenant
 */
export function getFirebaseAuth(tenantId?: string): Auth {
  const tenant = tenantId || getTenantId();
  
  if (!firebaseAuthInstances[tenant]) {
    const app = getFirebaseApp(tenant);
    firebaseAuthInstances[tenant] = getAuth(app);
    console.log(`🔐 [AUTH] Initialized Firebase Auth for tenant: ${tenant}`);
  }
  
  return firebaseAuthInstances[tenant];
}

/**
 * Get the current tenant configuration
 */
export function getCurrentTenantConfig() {
  const tenantId = getTenantId();
  const config = firebaseConfigs[tenantId as keyof typeof firebaseConfigs];
  
  console.log(`🔥 [FIREBASE] Using Firebase project: ${config.projectId} for tenant: ${tenantId}`);
  
  return {
    tenantId,
    config,
    app: getFirebaseApp(tenantId),
    auth: getFirebaseAuth(tenantId)
  };
}

// Export for use in other modules
export { firebaseConfigs }; 